import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import {
  updateVoD,
} from '../store/actions/vodActions';
import { storeStructure } from '../store/reducers';

export default {
  actionUpdate: updateVoD,
  attributeName: 'vodFiles',
  storeNode: storeStructure.VoD,
  title: 'Source File',
  helpText: 'The information about the VoD job output file.',
  fields: [
    {
      attributeName: 'vodNames',
      type: FormInputTypes.TEXT_SCROLL,
      label: 'Camera and file names',
      helpText: 'Name of the files and camera uploaded to encode.',
    },
    {
      attributeName: 'type',
      type: FormInputTypes.TEXT,
      label: 'Type',
      helpText: 'Type of video job: 360º, 180º, flat or control room.',
    },
    {
      attributeName: 'stereoMode',
      type: FormInputTypes.TEXT,
      label: 'Stereo Mode',
      helpText: 'Video format mode: mono, top-bottom, left-right.',
    },
  ],
};
